<template>
    <div class="fullPage">
        <div>
            <header></header>
            <!--{{ allSection }}-->
            <div class="prize">
                <span class="num">我的礼包数量×<span class="redNum">{{ prizeNum }}</span></span>
                <span class="open"
                      @click="openPrize()">开启</span>
                <p class="how"
                   @click="open">如何获得礼包？</p>
            </div>
            <!-- 查漏补缺-->
            <div class="chapter">
                <img src="../../assets/img/team/fu_tit01.png"
                     class="fuTit">
                <div class="main">
                    <div class="know">针对章节薄弱知识点复习</div>
                    <div class="weak">薄弱知识点，逐一突破</div>
                    <!--新版本-->
                    <router-link :to="{path: 'chapter'}"
                                 append
                                 v-if="isChapter">
                        <div class="select">{{ select }}<img src="../../assets/img/team/blue_jiantou.png"
                                 class="arrow"></div>
                        <ul>
                            <li class="every"
                                v-for="item in chapterList"><span class="selCon eslChapter">{{ item }}</span>
                                <span class="learn">去练习<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span></li>
                        </ul>
                        <p class="allChapter">查看全部章节</p>
                    </router-link>
                    <!--旧版本-->
                    <div @click="chapterOld()" v-if="!isChapter">
                    <router-link :to="{path: ''}">
                        <div class="select">{{ select }}<img src="../../assets/img/team/blue_jiantou.png"
                                 class="arrow"></div>
                        <ul>
                            <li class="every"
                                v-for="item in chapterList"><span class="selCon eslChapter">{{ item }}</span>
                                <span class="learn">去练习<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span></li>
                        </ul>
                        <p class="allChapter">查看全部章节</p>
                    </router-link>
                    </div>
                </div>
                <img src="../../assets/img/team/fu_tit03.png"
                     class="fuTit">
            </div>
            <!--超越自我-->
            <div class="chapter">
                <img src="../../assets/img/team/fu_tit02.png"
                     class="fuTit">
                <div class="main">
                    <div class="know">历年期末考试真题资料</div>
                    <div class="weak">小悠独家整理、助力期末考试</div>
                    <!--新版本-->
                    <router-link :to="{path:'exam'}"
                                 append v-if="isExam">
                        <div class="select">{{ test }}<img src="../../assets/img/team/blue_jiantou.png"
                                 class="arrow"></div>
                        <ul>
                            <li class="everyTest"
                                v-for="(item,index) in testList">
                                <div class="testPaper">
                                    <span class="selCon">{{ item }}</span>
                                    <span class="midTit">共{{ countList[index] }}题，难度{{ diffList[index] }}</span>
                                </div>
                                <span class="learn testLearn"
                                      v-if="doneList[index] === '去练习'">{{ doneList[index] }}<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span>
                                <span class="learn testLearn learned"
                                      v-if="doneList[index] === '已练习'">{{ doneList[index] }}<img src="../../assets/img/team/gray.png" class="arrow"></span>
                            </li>
                        </ul>
                        <p class="allChapter">更多试卷</p>
                    </router-link>
                    <!--旧版本-->
                    <div @click="examOld()" v-if="!isExam">
                    <router-link :to="{path:''}">
                        <div class="select">{{ test }}<img src="../../assets/img/team/blue_jiantou.png"
                                 class="arrow"></div>
                        <ul>
                            <li class="everyTest"
                                v-for="(item,index) in testList">
                                <div class="testPaper">
                                    <span class="selCon">{{ item }}</span>
                                    <span class="midTit">共{{ countList[index] }}题，难度{{ diffList[index] }}</span>
                                </div>
                                <span class="learn testLearn"
                                      v-if="doneList[index] === '去练习'">{{ doneList[index] }}<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span>
                                <span class="learn testLearn learned"
                                      v-if="doneList[index] === '已练习'">{{ doneList[index] }}<img src="../../assets/img/team/gray.png" class="arrow"></span>
                            </li>
                        </ul>
                        <p class="allChapter">更多试卷</p>
                    </router-link>
                    </div>
                </div>
                <img src="../../assets/img/team/fu_tit03.png"
                     class="fuTit">
            </div>
            <footer>
                <p>活动时间：2018.01.05~2018.01.19</p>
                <p>若有疑问，请添加小悠QQ：3196426910</p>
                <p>本次活动最终解释权归悠数学所有</p>
            </footer>
        </div>
        <!--如何获取-->
        <waysLayer :isClose="closeVal"
                   @fromWays="showFromWays"></waysLayer>
        <!--toast提示-->
        <classMessage :message="info"
                      v-if="hint"></classMessage>
        <!--礼物弹层-->
        <prize :isPrize="prizeVal"
               @fromPrize="showFromPrize"
               @fromPrizeChange="showPrizeChange"
               :num="prizeNum"></prize>
        <!--输入QQ号-->
        <inputQq :isInput="inputVal"
                 @fromInput="showFromInput"
                 @fromSubmit="showFromSubmit"></inputQq>
        <!--已经填写过qq号码-->
        <inputEd @fromInputed="showFromInputed"
                 :isInputed="inputedVal"
                 :qqNum="inoutQnum"></inputEd>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import waysLayer from '@/components/layer/waysLayer'
import classMessage from '@/components/layer/classMessage'
import prize from '@/components/layer/prize'
import inputQq from '@/components/layer/inputqq'
import inputEd from '@/components/layer/inputed'
import cookie from 'js-cookie'
// import { TEAM, CHAPTER_INFO } from '@/store/modules/team'
// import {  } from '@/store/modules/team'
export default {
    name: 'team',
    // computed: {
    //     ...mapGetters({
    //         allSection: TEAM
    //     })
    // },
    components: { waysLayer, classMessage, prize, inputQq, inputEd },
    data: function () {
        return {
            closeVal: false,
            prizeVal: false,
            inputVal: false,
            inputedVal: false,
            prizeNum: '0',
            chapterList: [],
            test: '',
            select: '',
            testList: [],
            countList: [],
            diffList: [],
            doneList: [],
            info: '你还没有获得礼包',
            hint: false,
            inoutQnum: '',
            allExam: '',
            userInfo: '',
            isFull: false,
            DEVICE_TYPE: '',
            _VERSION: '',
            newVer: '',
            isChapter: false,
            isExam: false
        }
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            window.scrollTo(0, 0)
        })
    },
    beforeRouteLeave (to, from, next) {
        this.isFull = false
        window.scrollTo(0, 0)
        next()
    },
    // created() {
    //     this.$store.dispatch(CHAPTER_INFO)
    // },
    mounted: function () {
        // 判断新旧版本
        this._VERSION = cookie.get('_VERSION')
        this.newVer = parseInt(this._VERSION.replace(/[^0-9]/ig, ''))
        if (this.newVer < 152) {
            this.isChapter = false
            this.isExam = false
        } else {
            this.isChapter = true
            this.isExam = true
        }
        // 查缺补漏
        this.$http.post('/zy/m/s/report/learning2/sectionMasterNoVip', {}, {}).then((response) => {
            this.allSection = response.data.ret
            // 默认教材
            if (this.allSection.textbookList.length) {
                for (let i = 0; i < this.allSection.textbookList.length; i++) {
                    if (this.allSection.selTextbookCode === this.allSection.textbookList[i].code) {
                        this.select = this.allSection.textbookList[i].name
                    }
                }
            }
            // 前三个章节
            if (this.allSection.sectionKpList.length) {
                for (let i = 0; i < 3; i++) {
                    if (this.allSection.sectionKpList[i]) {
                        this.chapterList.push(this.allSection.sectionKpList[i].name)
                    }
                }
            }
            this.isFull = true
        }, (response) => {
            // to do
        })
        // setTimeout(() => {
        // }, 200)
        // 超越自我
        // 查询用户版本年级信息
        this.$http.post('/zy/m/s/examActivity01/getUser', {}, {
            params: {
                code: this.$route.params.code
            }
        }).then((response) => {
            if (response.data.ret.user) {
                this.userInfo = response.data.ret.user
                this.inoutQnum = this.userInfo.qq
                switch (this.userInfo.textbookCategoryCode) {
                    case 15:
                        this.test = '苏科版'
                        break
                    case 30:
                        this.test = '人教新版'
                        break
                    case 23:
                        this.test = '华师大版'
                        break
                    case 31:
                        this.test = '北师新版'
                        break
                }
                switch (this.userInfo.grade) {
                    case 1:
                        this.test += ' 初一'
                        break
                    case 2:
                        this.test += ' 初二'
                        break
                    case 3:
                        this.test += ' 初三'
                        break
                }
                // 查询试卷
                this.$http.post('/zy/m/s/examActivity01/getPastExams', {}, {
                    params: {
                        code: this.$route.params.code,
                        type: '1',
                        category: this.userInfo.textbookCategoryCode,
                        grade: this.userInfo.grade
                    }
                }).then((response) => {
                    this.allExam = response.data.ret
                    for (let i = 0; i < 3; i++) {
                        if (this.allExam.exams1[i]) {
                            this.testList.push(this.allExam.exams1[i].name)
                            this.countList.push(this.allExam.exams1[i].questionCount)
                            if (this.allExam.exams1[i].difficulty >= 0 && this.allExam.exams1[i].difficulty < 0.4) {
                                this.diffList.push('困难')
                            } else if (this.allExam.exams1[i].difficulty >= 0.4 && this.allExam.exams1[i].difficulty < 0.8) {
                                this.diffList.push('中等')
                            } else if (this.allExam.exams1[i].difficulty >= 0.8 && this.allExam.exams1[i].difficulty <= 1) {
                                this.diffList.push('简单')
                            }
                            if (this.allExam.exams1[i].done) {
                                this.doneList.push('已练习')
                            } else {
                                this.doneList.push('去练习')
                            }
                        }
                    }
                }, (response) => {
                    // to do
                })
            }
        }, (response) => {
            // to do
        })
        // 礼包
        this.$http.post('/zy/m/s/examActivity01/getGiftCount', {}, {
            params: {
                code: this.$route.params.code
            }
        }).then((response) => {
            this.prizeNum = response.data.ret.count
        }, (response) => {
            // to do
        })
    },
    methods: {
        // 开启弹框
        open: function () {
            this.closeVal = true
        },
        // 关闭弹框
        showFromWays: function (closeCon) {
            this.closeVal = closeCon
        },
        // 关闭礼物列表
        showFromPrize: function (prizeClose) {
            this.prizeVal = prizeClose
        },
        // 是否填写qq号
        showPrizeChange: function (exchangeVal, isinputedprize) {
            this.inputVal = exchangeVal
            this.prizeVal = false
            this.inputedVal = isinputedprize
        },
        // 填写qq号码成功
        showFromSubmit: function (inputShow, number) {
            this.inputVal = !inputShow
            this.inoutQnum = number
            this.inputedVal = inputShow
        },
        // 返回中奖列表
        showFromInput: function (prizeShow) {
            this.prizeVal = prizeShow
            this.inputVal = !prizeShow
        },
        // 返回中奖列表
        showFromInputed: function (inputPrize) {
            this.inputedVal = !inputPrize
            this.inputVal = !inputPrize
            this.prizeVal = inputPrize
        },
        // 开启宝箱
        openPrize: function () {
            if (this.prizeNum !== '0') {
                this.prizeVal = true
            } else {
                this.hint = true
                this.info = '你还没有获得礼包'
                setTimeout(() => {
                    this.hint = false
                }, 3000)
            }
        },
        // 查漏补缺旧版本提示
        chapterOld: function () {
            this.hint = true
            this.info = '请升级到最新版本查看详情'
            setTimeout(() => {
                this.hint = false
            }, 2000)
        },
        // 超越自我旧版本提示
        examOld: function () {
            this.hint = true
            this.info = '请升级到最新版本查看详情'
            setTimeout(() => {
                this.hint = false
            }, 2000)
        }
    }
}
</script>

<style scoped>
.fullPage {
    position: absolute;
    width: 100%;
    min-height: 100%;
    background-color: #2ab7f7;
    top: 0px;
    left: 0px;
}

header {
    width: 718px;
    height: 328px;
    background-image: url('../../assets/img/team/bg.png');
    background-repeat: no-repeat;
    background-size: 718px 328px;
    margin: 40px auto 0 auto;
}

.prize {
    width: 690px;
    height: 214px;
    background-image: url('../../assets/img/team/prize_bg.png');
    background-repeat: no-repeat;
    background-size: 690px 214px;
    margin: 36px auto 0 auto;
}

.num {
    font-size: 35px;
    font-weight: 600;
    line-height: 180px;
    margin-left: 190px;
}

.redNum {
    color: #f14b40;
}

.open {
    display: inline-block;
    width: 130px;
    height: 50px;
    border-radius: 50px;
    border: 4px solid #000;
    background-color: #fff700;
    text-align: center;
    line-height: 50px;
    font-size: 32px;
    font-weight: 600;
    margin-left: 45px;
}

.how {
    font-size: 20px;
    color: #155c7b;
    margin-top: -5px;
    text-align: center;
}

.chapter {
    margin-top: 90px;
}

.fuTit {
    width: 750px;
    height: 100px;
    display: block;
    margin-bottom: -2px;
    margin-top: -2px;
}

.main {
    width: 750px;
    background-image: url('../../assets/img/team/fu_tit04.png');
    background-size: 750px;
}

.know {
    font-size: 35px;
    font-weight: 600;
    text-align: center;
}

.weak {
    font-size: 25px;
    font-weight: 600;
    color: #839096;
    margin-top: 20px;
    text-align: center;
}

.select {
    color: #007aff;
    font-size: 28px;
    font-weight: 600;
    margin-top: 30px;
    text-align: center;
    margin-bottom: 15px;
}

.every {
    width: 622px;
    height: 100px;
    border: 4px solid #000000;
    border-radius: 15px;
    margin: 0 auto;
    font-size: 30px;
    line-height: 100px;
    background-color: #e1feff;
    margin-top: 20px;
    color: #000;
}

.everyTest {
    width: 622px;
    height: 100px;
    border: 4px solid #000000;
    border-radius: 15px;
    margin: 0 auto;
    font-size: 30px;
    background-color: #e1feff;
    margin-top: 20px;
    color: #000;
}

.testPaper {
    width: 400px;
    padding-top: 20px;
    padding-left: 26px;
    display: inline-block;
}

.selCon {
    font-weight: 600;
    width: 400px;
    display: inline-block;
    overflow: hidden;
    padding-top: 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.eslChapter {
    padding-left: 26px;
}

.midTit {
    font-size: 23px;
    color: #326264;
}

.arrow {
    width: 16px;
    height: 25px;
    margin-left: 10px;
}

.learn {
    color: #007aff;
    font-size: 30px;
    font-weight: 600;
    margin-right: 26px;
    float: right;
}

.testLearn {
    padding-top: 35px;
}

.allChapter {
    font-size: 32px;
    color: #007aff;
    text-align: center;
    font-weight: 600;
    margin-top: 40px;
    padding-bottom: 3px;
}

footer {
    margin-top: 20px;
    color: #0781b9;
    font-size: 27px;
    text-align: center;
    line-height: 47px;
    margin-bottom: 25px;
}

.learned {
    color: #839096;
}
</style>



// WEBPACK FOOTER //
// team.vue?3c6db238